module.exports = __webpack_public_path__ + "img/gt.1c65445e.svg";